import { useNavigate } from "react-router-dom";
console.log("🔥 VideoActions OK – fichier unique chargé");

export default function VideoActions({
  liveActive,
  recording,
  hasVideo,
  uploading,
  onActivateCamera,
  onStartRecording,
  onStopRecording,
  onCancelVideo,
  onUpload,
  onFlipCamera,
}) {
  const navigate = useNavigate();

  return (
    <div className="studio-actions">

      {/* 📷 Caméra */}
      {!liveActive && !recording && (
        <button onClick={onActivateCamera} title="Activer caméra">
          📷
        </button>
      )}

      {/* 🔴 Enregistrer */}
      {liveActive && !recording && (
        <button onClick={onStartRecording} title="Démarrer enregistrement">
          🔴
        </button>
      )}

      {/* ⏹ Stop */}
      {recording && (
        <button onClick={onStopRecording} title="Arrêter">
          ⏹
        </button>
      )}

      {/* 🔄 Flip caméra */}
      {liveActive && !recording && (
        <button onClick={onFlipCamera} title="Changer caméra">
          🔄
        </button>
      )}

      {/* 🎵 NOUVEAU : Musique */}
      <button
        onClick={() => navigate("/music")}
        title="Catalogue musique"
      >
        🎵
      </button>

      {/* ❌ Annuler */}
      {hasVideo && !uploading && (
        <button onClick={onCancelVideo} title="Annuler">
          ❌
        </button>
      )}

      {/* ⬆️ Upload */}
      {hasVideo && !uploading && (
        <button onClick={onUpload} title="Envoyer">
          ⬆️
        </button>
      )}

      {/* ⏳ Upload en cours */}
      {uploading && (
        <button disabled title="Upload en cours">
          ⏳
        </button>
      )}

    </div>
  );
}
